import { split } from 'lodash/fp';

const getLanguageFrom = locale => split(/[-_]/, locale)[0];

export default getLanguageFrom;
